import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  Optional,
  Output,
} from '@angular/core';
import {ArticleBlockComponent} from '@tisa-group/client-ui/components/article-block';
import {TisaArticle, TisaCategory} from '@tisa-group/client-ui/models';
import {coerceBooleanProperty} from '@angular/cdk/coercion';

@Component({
  selector: 'tisa-article-block-metadata',
  templateUrl: './article-block-metadata.component.html',
  styleUrls: ['article-block-metadata.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBlockMetadataComponent {
  @HostBinding('class')
  readonly className = 'grid grid-rows-[1fr,auto] bg-white-500 p-5 grid gap-6';

  private _showShare = true;

  get publicationCategory(): TisaCategory | undefined {
    return this.articleBlockComponent?.article?.category;
  }

  get title(): string | undefined {
    return this.articleBlockComponent?.article?.title;
  }

  get publishedAt(): string | Date | undefined {
    return this.articleBlockComponent?.article?.publishedAt;
  }

  get link(): string | undefined {
    return this.articleBlockComponent?.link;
  }

  get categoryLink(): string | undefined {
    return this.articleBlockComponent?.categoryLink;
  }

  get showShare(): boolean {
    return this._showShare;
  }

  @Input()
  set showShare(value: boolean) {
    this._showShare = coerceBooleanProperty(value);
  }

  @Output()
  readonly onShare = new EventEmitter<TisaArticle>();

  constructor(
    @Optional()
    @Inject(ArticleBlockComponent)
    readonly articleBlockComponent: ArticleBlockComponent | undefined,
  ) {}

  onShareClick(): void {
    this.onShare.emit(this.articleBlockComponent?.article);
  }
}
